// extracted by mini-css-extract-plugin
export default {"container":"CircleBadge_container__+7rlk","value":"CircleBadge_value__xLbEI","mainContainer":"CircleBadge_mainContainer__of-8e","mainValue":"CircleBadge_mainValue__7Im57"};